/**
 * 应用入口文件
 * 初始化游戏实例
 */

import { GameManager } from './game-manager';
import { HTMLView } from './html-view';
import { InputManager } from './input-manager';
import { StorageManager } from './storage-manager';
import type { GameConfig } from './types';
import { GRID_SIZE, START_TILES } from './constants';
import '../css/main.css';

// 检测是否为触摸设备
function isTouchDevice(): boolean {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    ((navigator as { msMaxTouchPoints?: number }).msMaxTouchPoints ?? 0) > 0
  );
}

// 等待DOM加载完成
window.addEventListener('DOMContentLoaded', () => {
  // 根据设备类型添加对应的class到body
  if (isTouchDevice()) {
    document.body.classList.add('touch-device');
  } else {
    document.body.classList.add('keyboard-device');
  }

  // 创建游戏配置
  const config: GameConfig = {
    size: GRID_SIZE,
    startTiles: START_TILES,
  };

  // 创建各个管理器实例
  const view = new HTMLView();
  const inputManager = new InputManager();
  const storageManager = new StorageManager();

  // 创建游戏管理器
  const game = new GameManager(config, view, inputManager, storageManager);

  // 初始化游戏
  game.setup();

  // 在开发环境下将游戏实例暴露到全局
  if (import.meta.env.DEV) {
    (window as unknown as { game: GameManager }).game = game;
  }
});
